<template>
  <header class="header-page g_min_width">
    <!--  :style="{ 'background-image': `url(${homeData[enterpriseIndex].herderBanner}` }" -->
    <el-carousel
      height="555px"
      class="header-carousel"
      trigger="click"
      autoplay
      loop
      :interval="5000"
    >
      <el-carousel-item
        v-for="(item, idx) in homeDataItem.herderBanner || []"
        :key="idx"
      >
        <div
          class="header-carousel-item"
          :style="{ 'background-image': `url(${item}` }"
        ></div>
      </el-carousel-item>
    </el-carousel>
    <section class="header-page-top">
      <div class="g_width">
        <div class="g_d_flex g_flex_justify_space-between">
          <div class="g_d_flex">
            <div class="logo">
              <img alt="" :src="homeDataItem.logo" />
            </div>
            <div class="header-page-name">
              <h1>
                {{ homeDataItem.headerTitle }}
                <!-- <i></i> <i></i> <i></i> <i></i> <i></i> -->
              </h1>

              <template v-for="(item, index) in tipListInfo" :key="index">
                <!-- <span class="badge"><i></i>陕建云采高级会员</span> -->
                <span style="margin-top: 10px; display: inline-block">{{
                  item.title
                }}</span>
                <!-- <span>绿色建材认证</span> -->
              </template>
            </div>
          </div>
          <div class="g_d_flex">
            <div class="quickjump">
              <a href="javascript:void(0);" @click="openTenderIntention"
                ><img
                  alt=""
                  src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/header-icon1.png"
                />发送招标意向</a
              >
              <a href="javascript:void(0);" @click="isCollect = !isCollect">
                <img
                  alt=""
                  :src="isCollect ? collect : uncollected"
                />收藏店铺</a
              >
              <a href="javascript:void(0);" @click="openSharing"
                ><img
                  alt=""
                  src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/header-icon4.png"
                />分享店铺</a
              >
            </div>
            <!-- <div class="qrCode">
							<img alt="" src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qrCode.png">
							<p>移动端店铺</p>
						</div> -->
          </div>
        </div>
      </div>
    </section>
    <section class="header-page-bottom g_width">
      <div
        class="g_d_flex g_flex_justify_space-between g_flex_align_center"
        style="height: 120px"
      >
        <nav>
          <a
            v-for="item in navlList"
            :class="{ active: (mactedNav || '').includes(item.path) }"
            :key="item.path"
            @click="
              routerLinkTo({
                path: item.path,
                name: item.name,
              })
            "
            >{{ item.name }}</a
          >
        </nav>
        <el-input
          class="product-name"
          v-model="productName"
          clearable
          placeholder="请输入您要找的产品名称"
          v-if="mactedNav == '/home'"
        >
          <template #append>
            <el-button class="product-but" @click="searchProduct(productName)"
              >搜索</el-button
            >
          </template>
        </el-input>
      </div>
    </section>
  </header>
  <el-dialog
    class="hint-dialog g_herder_bodre_none_dialog"
    v-model="dialogVisible"
    title=""
    width="460px"
  >
    <div class="sharing">
      <div class="img">
        <img
          alt=""
          src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/qrCode.png"
        />
        <p>分享店铺给好友</p>
      </div>
      <div class="website">
        <a
          target="_black"
          href="https://jzkt.fwxgx.com/courses/17313.htmlinvitationCode=Mq8m4ksc2CR&source=izktCoursesShare"
          >https://jzkt.fwxgx.com/courses/17313.htmlinvitationCode=Mq8m4ksc2CR&source=izktCoursesShare</a
        >
        <p>
          <span class="g_but g_but_blue" @click="copy('文本')">复制</span
          >链接,即可将网页分享至好友
        </p>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    class="hint-dialog g_herder_bodre_none_dialog g_dialog"
    v-model="tenderIntentionVisible"
    title="对该店铺发送以下招标意向："
    width="790px"
  >
    <div class="tenderIntention">
      <el-checkbox-group v-model="checkList">
        <el-checkbox
          v-for="item in tenderIntentionList"
          :key="item.val"
          :label="item.val"
          >{{ item.name }}</el-checkbox
        >
      </el-checkbox-group>
      <el-divider />
      <p class="prompt">
        您勾选好采购任务后，我们会以短信形式推送给供应商，您的招标意向；如您对短信内容无意义可点击按钮发送短信通知
      </p>
      <p class="messageContent">
        短信内容：【陕建云采】有采方对您发送招标意向，招标任务为陕建一建-安装公司-一工程公司渭南文化中心弱电线缆材料计划采购任务；黄南州博物馆、黄南州非物质文化遗产博物馆线缆采购采购任务。免费报名：https://https://www.sjyunc.com/gjc/seller/
      </p>
      <div class="g_text_align_center" style="margin-top: 30px">
        <span
          class="g_but g_padding_5_15"
          @click="tenderIntentionVisible = false"
          >取消</span
        >
        <el-button
          class="g_but g_but_blue g_padding_5_15"
          :loading="loading"
          @click="sendMes"
          >内容确认无误，发送短信通知</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script setup name="Header">
import useClipboard from "vue-clipboard3";
import { ElMessage, ElLoading } from "element-plus";

import { ref, reactive, computed, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getItem } from "@/plugins/data";
import { getIndex } from "@/plugins/util";
const enterpriseIndex = ref(getIndex());
const { toClipboard } = useClipboard();
const router = useRouter();
const collect =
  "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/starRating.png";
const uncollected =
  "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/header-icon3.png";
let homeDataItem = ref(getItem('homeData',getIndex()));

const navlList = reactive([
  {
    name: "首页",
    path: "/home",
  },
  {
    name: "产品列表",
    path: "/productList",
  },
  {
    name: "工程案例",
    path: "/case",
  },
  {
    name: "中标信息",
    path: "/information",
  },
  {
    name: "综合评价",
    path: "/evaluation",
  },
  {
    name: "联系我们",
    path: "/contact",
  },
]);
let isCollect = ref(false);
let dialogVisible = ref(false);
let loading = ref(false);
let tenderIntentionVisible = ref(false);
let checkList = ref(["1", "3"]);
let productName = ref("");

let tipListInfo = ref((getItem('tipData',getIndex()) || {}).info);

let tenderIntentionList = ref([
  {
    name: "【RW-WZ-202211-002166】陕建一建-安装公司-一工程公司渭南文化中心弱电线缆材料计划采购任务",
    val: "1",
  },
  {
    name: "【RW-WZ-202204-001396】黄南州博物馆、黄南州非物质文化遗产博物馆线缆采购采购任务",
    val: "2",
  },
  {
    name: "【RW-WZ-202101-001708】银川市妇幼保健院新建产科大楼及配套地下停车场综合弱电线缆物资采购采购任务",
    val: "3",
  },
]);

const mactedNav = computed(() => {
  let href = router.currentRoute.value.href;
  if ((href || "").indexOf("/productDetail") > -1) {
    return "/productList";
  }
  return href;
});

function searchProduct(name) {
  let query = router.currentRoute.value.query || {};
  router.push({ path: "/searchList", query: { ...query,typeName: name } });
}
const copy = async (val) => {
  await toClipboard(val);
  ElMessage({
    message: "已复制",
    type: "success",
  });
};

function openSharing() {
  dialogVisible.value = true;
}
function openTenderIntention() {
  tenderIntentionVisible.value = true;
}
function sendMes() {
  loading.value = true;
  setTimeout(() => {
    ElMessage({
      message: "已发送",
      type: "success",
    });
    loading.value = false;
    tenderIntentionVisible.value = false;
  }, 1000);
}

const routerLinkTo = ({ path, name }) => {
	const {query} = router.currentRoute.value || {};
  if('type' in query){
    delete query.type
  }
  // 采购、或供应商账号信息一致的可直接查看
  router.push({
    path: path,
    query: query || {},
  });
};
</script>
<style  lang="scss">
@import "./header.scss";
</style>
